document.addEventListener('DOMContentLoaded', function () {

  var stickyAtc = document.getElementById('rtroStickyAtc');
  var nativeAtc = document.querySelector('.rtro-atc-btn');

  if (stickyAtc && nativeAtc) {
    function checkAtcVisibility() {
      var rect = nativeAtc.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyAtc.classList.add('show');
      } else {
        stickyAtc.classList.remove('show');
      }
    }
    window.addEventListener('scroll', checkAtcVisibility);
    window.addEventListener('load', checkAtcVisibility);
  }

  document.querySelectorAll('.rtro-variant-swatch:not(.sold-out)').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var group = swatch.closest('.rtro-variant-options');
      if (!group) return;
      group.querySelectorAll('.rtro-variant-swatch').forEach(function (s) {
        s.classList.remove('selected');
      });
      swatch.classList.add('selected');

      var variantId = swatch.getAttribute('data-variant-id');
      var variantName = swatch.getAttribute('data-variant-name');
      var hiddenInput = document.querySelector('input[name="id"]');
      if (hiddenInput && variantId) {
        hiddenInput.value = variantId;
      }
      var nameDisplay = document.querySelector('.rtro-variant-name-display strong');
      if (nameDisplay && variantName) {
        nameDisplay.textContent = variantName;
      }

      var available = swatch.getAttribute('data-available') !== 'false';
      var atcBtn = document.querySelector('.rtro-atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  });

  document.querySelectorAll('.rtro-qty-select').forEach(function (qtyBlock) {
    var qtySpan = qtyBlock.querySelector('span');
    var qtyInput = qtyBlock.querySelector('input[type="hidden"]') ||
                   document.querySelector('input[name="quantity"]');
    var qty = parseInt(qtySpan ? qtySpan.textContent : '1', 10) || 1;

    var buttons = qtyBlock.querySelectorAll('button');
    if (buttons[0]) {
      buttons[0].addEventListener('click', function () {
        if (qty > 1) qty--;
        if (qtySpan) qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    }
    if (buttons[1]) {
      buttons[1].addEventListener('click', function () {
        qty++;
        if (qtySpan) qtySpan.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
      });
    }
  });

  document.querySelectorAll('.rtro-accordion-head').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.closest('.rtro-accordion-item');
      if (item) item.classList.toggle('open');
    });
  });

  document.querySelectorAll('.rtro-gallery-thumb').forEach(function (thumb) {
    var fullSrc = thumb.getAttribute('data-full-src');
    if (fullSrc) {
      var preload = new Image();
      preload.src = fullSrc;
    }
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.rtro-gallery-main img');
      if (mainImg && fullSrc) {
        mainImg.src = fullSrc;
      }
      document.querySelectorAll('.rtro-gallery-thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  document.querySelectorAll('.rtro-filter-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = chip.closest('.rtro-filter-group');
      if (!group) return;
      group.querySelectorAll('.rtro-filter-chip').forEach(function (c) {
        c.classList.remove('active');
      });
      chip.classList.add('active');
    });
  });

  document.querySelectorAll('.rtro-product-card').forEach(function (card) {
    var link = card.querySelector('a[href]');
    if (!link) return;
    var targetUrl = link.getAttribute('href');
    var navigated = false;
    var touchStartX = 0;
    var touchStartY = 0;

    card.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches.length > 0) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }
    }, { passive: true });

    card.addEventListener('touchend', function (e) {
      if (navigated) return;
      if (e.target.closest('form') || e.target.closest('.quick-add')) {
        return;
      }
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      var deltaX = Math.abs(touch.clientX - touchStartX);
      var deltaY = Math.abs(touch.clientY - touchStartY);
      if (deltaX < 10 && deltaY < 10) {
        navigated = true;
        window.location.href = targetUrl;
      }
    }, { passive: true });

    card.addEventListener('click', function (e) {
      if (navigated) return;
      if (e.target.closest('form') || e.target.closest('.quick-add')) {
        return;
      }
      navigated = true;
      window.location.href = targetUrl;
    });
  });
});